import React from 'react';

export default class  Page6 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt people">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <div className="border_subtitle">‘Content to process’ shift</div>
                                            <p>Sometimes, people will not want to enter a discussion on a
                                                particular issue, and will try to block your assertiveness by
                                                using humour or distraction to move off topic. In this
                                                situation, it can often be helpful to then challenge them on
                                                this behaviour directly, before then moving on to the issue you
                                                are trying to address.</p>
                                            <p><span className="brown brownbold">Example: </span><span
                                                className="subtiltereg">‘You’re getting off the point. I’m starting to feel frustrated because I feel you’re not listening.’</span>
                                            </p>
                                            <div className="border_subtitle">Defusing</div>
                                            <p>Letting someone cool down before discussing an issue.</p>
                                            <p><span className="brown brownbold">Example: </span><span
                                                className="subtiltereg">‘I can see that you’re upset, and I can even understand part of your reaction. Let’s talk about this later.’</span>
                                            </p>
                                            <p>If they try to stay with it, you always have the right to walk
                                                away.</p>
                                            <div className="border_subtitle">Assertive inquiry/stop action</div>
                                            <p>This is similar to the ‘content to process shift’.<span
                                                className="subtiltereg"> ‘Let’s hold it for a minute, something isn’t working, what just happened? How did we get into this argument?’</span> This
                                                helps identify the real issue when an argument becomes
                                                generalised and bigger than the immediate topic.</p>
                                            <p>Examples include:</p>
                                            <p className="subtiltereg">Chris: ‘Can you help me with this
                                                statistics problem?’ </p>
                                            <p className="subtiltereg">Kim: ‘No I can’t! You know how much I
                                                have to do today!’</p>
                                            <p className="subtiltereg">Chris: ‘Why is it such a problem to take
                                                15 minutes to help me with this? You told me yesterday that you
                                                would!’</p>
                                            <p className="subtiltereg">Kim: ‘I get so tired of you always asking
                                                me to do these things right when I’m in the middle of
                                                something!’</p>
                                            <p className="subtiltereg">Chris: ‘Hold on, let’s take a break here.
                                                How did we get from my stats problem to you being tired of my
                                                interruptions?’</p>
                                            <p>The real problem here is not that Chris asked for help, it’s that
                                                he chose a bad time to ask. Through the stop action,<span
                                                    className="subtiltereg"> ‘let’s take a break here’</span> ,
                                                the two people become aware of the real problem.</p>
                                            <div className="border_subtitle">Summarising</div>
                                            <p>Summarising the situation helps to make sure you understand the
                                                other person.</p>
                                            <p><span className="brown brownbold">Example:</span><span
                                                className="subtiltereg"> ‘So what you’re trying to tell me is... ’</span>
                                            </p>
                                            <div className="border_subtitle">Be specific</div>
                                            <p>It’s vital to be clear about what you want done. This helps
                                                prevent distractions.</p>
                                            <p><span className="brown brownbold">Example:</span><span
                                                className="subtiltereg"> ‘The thing I really wish is that you’d pick your clothes up off the floor.’</span>
                                            </p>
                                            <p>Aim to communicate assertively – this means you ask for what you
                                                want clearly, openly and explain why in a rational, unemotional
                                                way.</p>


                                            <div className="left-btn"><div
                                                onClick={this.props.handleChangePage('Page5')}
                                                className="button-next-previous-done">&lt;&lt; Previous </div></div>
                                            <div className="right-btn"><div onClick={this.props.handleChangePage('Page7')}
                                                                          className="button-next-previous-done">Next &gt;&gt;</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}